import { Fault } from '@docma-mm-core/fault/fault';
import { Group } from '@docma-mm-core/group/group';
import { Activity, ActivityData } from './activity';
import {ActivityPatchModeEnum} from "@docma-mm-core/activity/activity-patch-mode.enum";

export class MultiActivity {
    group: Group;
    entities: { Fault: Fault, Activity: Activity, IsInitActivity: boolean}[];
    patchMode?: ActivityPatchModeEnum;
}

export class MultiActivityData {



    constructor(activities: ActivityData[], faultMap?: Map<string, string>) {
        this.activities = activities;

        const activityBase = new ActivityData();
        activityBase.Date = activities[0].Date;
        activityBase.Description = activities[0].Description;
        activityBase.DueDate = activities[0].DueDate;
        activityBase.ReplyUntil = activities[0].ReplyUntil;
        activityBase.Group = activities[0].Group;
        activityBase.Status = activities[0].Status;
        this.activity = activityBase;

        for (const a of activities) {
            let faultUid = null;
            if (faultMap) {
                faultUid = faultMap.get(a.UniqueId);
            }
            const faultActivity = { Activity: { Id: a.Id, UniqueId: a.UniqueId }, Fault: { Id: a.FaultId, UniqueId: faultUid }};
            this.faultActivities.push(faultActivity);
        }
    }

    activities: ActivityData[];
    activity: ActivityData;
    faultActivities: { Activity: { Id: number, UniqueId: string }, Fault: { Id: number, UniqueId: string }}[] = [];

    set Activity(value: any) {
      this.activity = value;
    }

    get Activity() {
      return this.activity;
    }

    set FaultActivities(value: any) {
      this.faultActivities = value;
    }

    get FaultActivities() {
      return this.faultActivities;
    }
}
